import React, { Fragment } from 'react'
import Spinner from '../Spinner'
import { Combobox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { RxCross1 } from 'react-icons/rx'
import { pageModel } from '../../utils/model'
import SearchPicker from '../common/SearchPicker'

const AccountPicker = (props) => {

    const { state } = props

    const option = (account) => <span>{`${account.code}, ${account.name}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}` : ""}
            option={(account) => option(account)}
        />
    )
}

export default AccountPicker